import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadSubmissionActivity,
  loadSubmissionActivityFail,
  loadSubmissionActivitySuccess,
  loadWeightActivity,
  loadWeightActivityFail,
  loadWeightActivitySuccess,
  loadMealActivity,
  loadMealActivityFail,
  loadMealActivitySuccess,
  loadInteractionMetrics,
  loadInteractionMetricsFail,
  loadInteractionMetricsSuccess,
  loadPendingInvitations,
  loadPendingInvitationsFail,
  loadPendingInvitationsSuccess,
  loadEventLogs,
  loadEventLogsSuccess,
  loadEventLogsFail,
} from '../actions/admin-statistics.actions';
import { AdminStatisticsApiService } from '../services/admin-statistics-api.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class AdminStatisticsEffects {
  loadSubmissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSubmissionActivity),
      switchMap(({ dateFrom, dateTo }) =>
        this.api.getAllSubmissionActivity(dateFrom, dateTo).pipe(
          map((items) => loadSubmissionActivitySuccess({ items })),
          catchError(() => of(loadSubmissionActivityFail()))
        )
      )
    )
  );

  loadWeight$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadWeightActivity),
      switchMap(({ startDate, endDate }) =>
        this.api.getAllWeightActivity(startDate, endDate).pipe(
          map((items) => loadWeightActivitySuccess({ items })),
          catchError(() => of(loadWeightActivityFail()))
        )
      )
    )
  );

  loadMeal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMealActivity),
      switchMap(({ startDate, endDate }) =>
        this.api.getAllMealActivity(startDate, endDate).pipe(
          map((items) => loadMealActivitySuccess({ items })),
          catchError(() => of(loadMealActivityFail()))
        )
      )
    )
  );

  loadInteractionMetrics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInteractionMetrics),
      switchMap(() =>
        this.api.getInteractionMetrics().pipe(
          map((items) => loadInteractionMetricsSuccess({ items })),
          catchError(() => of(loadInteractionMetricsFail()))
        )
      )
    )
  );

  loadPendingInvitations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPendingInvitations),
      switchMap(() =>
        this.api.getAllPendingInvitations().pipe(
          map((items) => loadPendingInvitationsSuccess({ items })),
          catchError(() => of(loadPendingInvitationsFail()))
        )
      )
    )
  );

  loadEventLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEventLogs),
      switchMap(() =>
        this.api.getEventLogs().pipe(
          map((items) => loadEventLogsSuccess({ items })),
          catchError(() => of(loadEventLogsFail()))
        )
      )
    )
  );

  constructor(private actions$: Actions, private api: AdminStatisticsApiService) {}
}
